import { redirect } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';

// beforeLoad guard for platform-admin-only admin pages (ADR-018). The parent
// /admin route already let ADMIN + TEACHER through; this bounces TEACHER (a
// course-scoped role) to /admin/courses (the only platform surface they can use —
// the Dashboard's stats endpoint is ADMIN-only, ADR-018) so they never hit a 403.
export function requireAdmin(): void {
  const { user } = useAuth.getState();
  if (user?.role !== 'ADMIN') throw redirect({ to: '/admin/courses' });
}
